<template>
  <el-dialog class="dialogShareMessage" top="10vh" v-if="showMessageShareMulti" width="750px"
    :visible.sync="showMessageShareMulti" @close="closeDialog" :close-on-click-modal="false" :destroy-on-close="true"
    append-to-body>
    <div slot="title" class="d-flex align-items-center justify-content-between py-3 px-12">
      <span class="fw-700 text-grey900 font-16">Chuyển tiếp tin nhắn</span>
      <el-popover placement="bottom" trigger="click">
        <div class="conversation-box-popover">
          <div class="d-flex align-items-center flex-grow-1 my-1">
            <div class="radio-button" :class="tagType === 0 && 'radio-button-active'" @click="changeTagOpt(0)">
              <span>Tất cả ({{ getTagCount(0) }})</span>
            </div>
            <div class="radio-button" :class="tagType === 1 && 'radio-button-active'" @click="changeTagOpt(1)">
              <span>Thẻ chỉ định ({{ getTagCount(1) }})</span>
            </div>
            <div class="radio-button" :class="tagType === 2 && 'radio-button-active'" @click="changeTagOpt(2)">
              <span>Thẻ thường ({{ getTagCount(2) }})</span>
            </div>
          </div>
          <el-input class="ms-1" placeholder="Tìm kiếm thẻ đã tạo" v-model="searchTagName" size="small"></el-input>
          <div class="d-flex flex-wrap text-center overflow-auto mt-2 px-1"
            style="max-width: 500px; max-height: 400px; min-width: 500px">
            <div v-for="(item, index) in listTagView" :key="index">
              <div class="d-flex pointer" @click="addOrRemoveTag(item)">
                <TagV2 :data="item" :inactive="!isSelected(item)" :item="item" :selected="isSelected(item)"
                  :is-button="true" />
              </div>
            </div>
          </div>
        </div>

        <el-tooltip slot="reference" effect="dark" content="Lọc theo tag" placement="top">
          <el-button size="small" class="d-flex text-blue500 me-5">
            <div class="d-flex">
              <span>Lọc theo thẻ đã gắn ({{ selectedTags.length }})</span>
              <IconV2 name="v2-arrow1_drop_down" color="#1769D7" />
            </div>
          </el-button>
        </el-tooltip>
      </el-popover>
    </div>
    <el-divider class="my-0 mb-1" />
    <div style="z-index: 999">
      <div>
        <div class="d-flex align-items-center justify-content-between mb-1 px-2">
          <div class="d-flex align-items-center flex-grow-1 mt-1">
            <div class="radio-button" :class="conversationType === 'all' && 'radio-button-active'"
              @click="changeConversationType('all')">
              <span>Tất cả</span>
            </div>
            <div class="radio-button" :class="conversationType === 'personal' && 'radio-button-active'"
              @click="changeConversationType('personal')">
              <span>Cá nhân</span>
            </div>
            <div class="radio-button" :class="conversationType === 'group' && 'radio-button-active'"
              @click="changeConversationType('group')">
              <span>Nhóm</span>
            </div>
          </div>

          <el-input ref="input" style="width: 220px" placeholder="Tìm kiếm" size="small" clearable v-model="searchKey"
            @input="searchKeyChanged()" prefix-icon="el-icon-search"></el-input>

          <el-select class="ms-2" style="width: 150px" placeholder="Sắp xếp theo" size="small" v-model="sortOption"
            @input="searchKeyChanged()" prefix-icon="el-icon-search">
            <el-option label="A - Z" key="toName" value="toName"></el-option>
            <el-option label="Liên hệ gần đây" key="lastMessageTime" value="lastMessageTime"></el-option>
          </el-select>
        </div>

        <!-- <div
          id="tag-container"
          style="padding: 5px; border: 1px solid #e0e4e8; border-radius: 10px; max-height: 64px; overflow: auto">
          <span
            v-for="item in app.tags"
            class="me-2"
            :key="item.id"
            @click="addOrRemoveTag(item)">
            <TagCustom
              :item="item"
              :selected="isSelected(item)"
              :is-button="true" />
          </span>
        </div> -->

        <div class="divider-custom-zalo"></div>
        <div class="d-flex">
          <div style="flex: 1" class="border-right">
            <div class="add-share-popup-left" style="flex: 1">
              <div v-for="(itemGroup, index) in groupViews" :key="index">
                <div
                  class="font-14 text-grey600 py-1 px-12 border-bottom border-top bg-base-milk d-flex justify-content-between">
                  <span class="fw-700">
                    {{ itemGroup[0].swName ? itemGroup[0].swName.charAt(0).toUpperCase() :
                      itemGroup[0].toName.charAt(0).toUpperCase() }}
                  </span>
                  <span>{{ itemGroup.length }}</span>
                </div>
                <div class="select-item rounded-2" v-for="item in itemGroup" :key="item.id">
                  <div class="d-flex py-2 pointer align-items-center" @click.stop.prevent="selectItem(item)">
                    <el-checkbox class="ms-3" :value="checkSelectedContact(item.id)"></el-checkbox>

                    <el-image :src="item.avatar" style="border-radius: 1000px" class="mx-2 mb-1 img-select">
                      <div slot="error" class="image-slot">
                        <el-image src="/assets/images/no-avatar.png" style="border-radius: 1000px"
                          class="img-select"></el-image>
                      </div>
                    </el-image>
                    <div class="d-flex flex-column justify-content-between">
                      <div style="white-space: normal" class="flex-1 font-size-14 text-1-line text-grey900 fw-700">
                        {{ item.toName }}
                        <span v-if="item.swName" class="font-14 text-grey600 fw-400">
                          | {{ item.swName }}
                        </span>
                      </div>
                      <ListTagEllipsis v-if="item.tags.length" class="ms-0 mt-1 mb-0" :tags="item.tags || []" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-start bg-base-milk border-bottom border-top py-2 ms-2 mt-1">
              <span style="width: 85px">Hiển thị: 20</span>
              <el-pagination style="width: 200px; font-weight: 400 !important" small background
                layout="prev, pager, next" :current-page="pageInfo.page" :total="pageInfo.total"
                :page-size="pageInfo.pageSize" @current-change="currentSwPageChanged" @prev-click="pageInfo.page -= 1"
                @next-click="pageInfo.page += 1"></el-pagination>
            </div>
          </div>
          <div class="position-absolute ms-2 mt-1"
            v-bind:style="conversationsSelected.length === 0 ? 'right:-50% ' : 'position:static !important'"
            :class="conversationsSelected.length > 0 ? 'left-group' : 'left-group no-item'">
            <div class="font-size-14 fw-semibold mb-1 d-flex align-items-center justify-content-between"
              style="width: 335px">
              <div style="color: #081c36">
                Tài khoản đã chọn
                <span class="ms-1 font-size-14">({{ conversationsSelected.length }}/{{ LIMIT }})</span>
              </div>
              <div class="me-3 pointer" @click="removeAllConversations">
                <IconV2 name="v2-delete_sweep" size="20px" />
              </div>
            </div>
            <div class="add-share-popup-right" style="overflow-y: auto; overflow-x: hidden">
              <div class="mt-2 me-2 rounded-2 d-flex align-items-center justify-content-between"
                style="background-color: rgba(225, 237, 253, 0.6); color: #42444d; width: 320px; border: thin solid #c2dcff"
                v-for="item in conversationsSelected" :key="item.id">
                <div class="position-relative rounded-2 d-flex pointer d-flex align-items-center flex-grow-1 py-1"
                  @click.stop.prevent="unSelect(item.id)">
                  <!-- <el-avatar :src="item.avatar" class="ms-1 me-2 img-selected" />-->
                  <el-image :src="item.avatar" style="border-radius: 1000px" class="ms-1 me-2 img-selected">
                    <div slot="error" class="image-slot">
                      <el-image src="/assets/images/no-avatar.png" style="border-radius: 1000px"
                        class="img-selected"></el-image>
                    </div>
                  </el-image>
                  <div>
                    <div style="white-space: normal" class="text-1-line font-size-14 text-break me-1">
                      <span>{{ item.toName }}</span>
                    </div>
                    <div style="white-space: normal" class="text-1-line font-13 text-grey600 text-break me-1">
                      <span>{{ item.swName }}</span>
                    </div>
                  </div>
                </div>
                <div class="me-2 pointer" @click.stop.prevent="unSelect(item.id)">
                  <IconV2 name="v2-close" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-2">
          <div class="d-flex mt-1 pointer mb-1" v-if="shareContactCard ? true : false">
            <div class="mx-1 align-self-center">[Danh thiếp]</div>
          </div>
          <div class="" v-else>
            <div v-for="message in messages" :key="message.id.msgId">
              <div class="bg-blue100 rounded-2 border d-flex pointer justify-content-between mb-1 px-2 pb-2 pt-1 mt-2"
                v-if="isPhoto(message) || isVideo(message) || isCardBusiness(message) || isFile(message) || message.isArray">
                <div v-if="isFile(message)" class="border rounded-2 pb-1 px-1" style="background-color: white">
                  <ChatFileV3 :file="message" :account-id="conversation.accountId" :message-id="message.id"
                    :preventDownload="true" />
                </div>
                <img v-else-if="!message.isArray && !message.groupImages.length" :src="getThumbUrl(message)"
                  class="rounded-1 mt-1 img-thumb" />
                <div v-if="message.groupImages.length > 0"
                  class="mx-1 pt-1 d-flex flex-grow-1 justify-content-between align-items-center font-14 fw-500 text-blue400">
                  <div class="d-flex">
                    <img v-for="(img, idx) in groupImagesContent(message).filter((item, index) => index < 5)" :key="idx"
                      :src="img" class="rounded-1 img-thumb me-2" />
                    <div v-if="groupImagesContent(message).length > 5"
                      class="rounded-1 img-thumb d-flex align-items-center justify-content-center"
                      style="background-color: #dcdfe9">
                      {{ groupImagesContent(message).length - 5 }}+
                    </div>
                  </div>
                  <span>{{ message.groupImages.length }} ảnh được chọn</span>
                </div>
                <div v-if="isCardBusiness(message)" class="mx-1 align-self-center">
                  [Danh thiếp]
                </div>
                <div v-if="message.isArray" class="mx-1 d-flex flex-grow-1 align-items-center justify-content-between">
                  <div v-if="message.type === 'media'" class="d-flex">
                    <img v-for="(img, idx) in getMultiMessageContent(message).filter((item, index) => index < 5)"
                      :key="idx" :src="img" class="rounded-1 img-thumb me-2" />
                    <div v-if="getMultiMessageContent(message).length > 5"
                      class="rounded-1 img-thumb d-flex align-items-center justify-content-center"
                      style="background-color: #dcdfe9">
                      {{ getMultiMessageContent(message).length - 5 }}+
                    </div>
                  </div>
                  <div v-if="message.type === 'share.file'" class="d-flex">
                    <div class="border rounded-2 pb-1 px-1" style="background-color: white">
                      <ChatFileV3 :file="message.messages[0]" :account-id="conversation.accountId"
                        :message-id="message.messages[0].id" :preventDownload="true" />
                    </div>
                    <div v-for="(file, index) in message.messages.filter((item, i) => i > 0)" :key="index"
                      class="border pb-1"
                      style="background-color: white; width: 10px; border-top-right-radius: 5px; border-bottom-right-radius: 5px">
                    </div>
                  </div>
                  <span class="font-14 fw-500 text-blue400">{{ message.messages.length }} {{ message.type
                    === "media" ? "ảnh" : "tệp" }} được chọn</span>
                </div>
              </div>
                        <el-input class="mt-2" type="textarea" rows="2" placeholder="Thêm mô tả"
            :autosize="{ minRows: 2, maxRows: 3 }" v-model="message.messageContent"></el-input>
            </div>

          </div>

        </div>

        <div class="d-flex justify-content-end px-12 py-2">
          <span class="edit-button font-size-16 me-3 fw-semibold rounded-2 pointer py-2 px-3" @click="closeDialog()">
            Hủy
          </span>
          <!--      <span class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3" @click="send()">Chia sẻ</span>-->
          <el-button :disabled="isDisable" class="share-button font-size-16 fw-semibold rounded-2 pointer py-2 px-3"
            :loading="isDisable" @click="send">
            Hoàn thành
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>


<script>
import { COMMON } from "../../lib/Common";
import ListTagEllipsis from "../ListTagEllipsis.vue";
import ChatFileV3 from "./ChatFileV3.vue";
import TagV2 from "../TagV2.vue";
import { groupByName } from "../../lib/text-utils";
import { removeVietnameseTones } from "../../lib/text-utils";

export default {
  props: ["showMessageShareMulti", "conversation", "messageList", "accountId", "shareContactCard", "messages"],
  components: { ListTagEllipsis, ChatFileV3, TagV2 },
  data() {
    return {
      isDisable: false,
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      searchKey: "",
      sortOption: "toName",
      conversations: [],
      conversationsSelected: [],
      selectedTags: [],
      views: [],
      groupViews: [],
      LIMIT: 100,
      conversationType: "all",
      tagType: 0,
      searchTagName: "",
    };
  },
  computed: {
    listTagView() {
      let view = [];
      switch (this.tagType) {
        case 0: {
          view = this.app.tags;
          break;
        }
        case 1: {
          view = this.app.tags.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.app.tags.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },
  },
  watch: {
    selectedTags: function () {
      this.search();
    },
  },
  methods: {
    isFile(message) {
      return message.msgType === COMMON.CHAT_FILE;
    },
    isText(message) {
      return message.msgType === "webchat";
    },
    isPhoto(message) {
      return message.msgType === "chat.photo";
    },
    isVideo(message) {
      return message.msgType === COMMON.CHAT_VIDEO;
    },
    getMultiMessageContent(message) {
      return message.messages.map((item) => {
        // return this.getCloudUrl(JSON.parse(item.content).href, item);
        return JSON.parse(item.content).href;
      });
    },
    groupImagesContent(message) {
      return message.groupImages.map((item) => {
        // return this.getCloudUrl(JSON.parse(item.content).href, item);
        return JSON.parse(item.content).href;
      });
    },
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.app.tags.length;
        }
        case 2: {
          return this.app.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.app.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    changeTagOpt(tagType) {
      this.tagType = tagType;
      // switch (tagType) {
      //   case 0: {
      //     break;
      //   }
      //   case 1: {
      //     break;
      //   }
      //   case 2: {
      //     break;
      //   }
      //   default:
      //     break;
      // }
    },
    getThumbUrl(message) {
      if (this.isFile(message) && Object.keys(message?.photoContent).length > 1) {
        return this.fileTypeIcon(message?.photoContent?.extension);
      }
      let data = message?.photoContent?.thumbUrl;
      return data;
    },
    isActionText(message) {
      try {
        let con = JSON.parse(message.content);
        if (["msginfo.actionlist", "rtf"].includes(con.action)) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },
    getPhotoList(message) {
      this.messageList
        .filter((p) => p.msgType == "chat.photo")
        .forEach((item) => {
          let params = JSON.parse(JSON.parse(item.content).params);
          if (params.is_group_layout) {
            if (params.group_layout_id == message.groupLayoutId && item.type != "timeline") {
              const existImg = message.groupImages.find((i) => i.id === item.id || i.idInGroup == params.id_in_group);
              if (!existImg) {
                message.groupImages.push({ ...item, idInGroup: params.id_in_group });
              }
            }
          }
        });
    },
    getPhotoParams(item) {
      let photo = JSON.parse(item.content);
      let params = JSON.parse(photo.params);
      let data = {};
      data.title = photo.title;
      data.oriUrl = photo.href;
      data.thumbUrl = photo.thumb;
      data.hdUrl = params.hd;
      data.width = params.width;
      data.height = params.height;
      data.properties = null;
      data.normalUrl = photo.href;
      if (this.isPhotoGroup(item)) {
        data.totalItemInGroup = params.total_item_in_group;
        data.idInGroup = params.id_in_group;
        data.isGroupLayout = params.is_group_layout;
        data.groupLayoutId = params.group_layout_id;
      }
      return data;
    },
    getFileParams(message) {
      let content = JSON.parse(message.content);
      let msgInfo = {};
      msgInfo.url = content.href;
      msgInfo.fileName = content.title;
      let params = JSON.parse(content.params);
      msgInfo.extension = params.fileExt;
      msgInfo.checksum = params.checksum;
      msgInfo.fdata = params.fdata;
      msgInfo.fType = params.fType;
      msgInfo.size = params.fileSize;
      return msgInfo;
    },
    getVideoParams(message) {
      let content = JSON.parse(message.content);
      let params = JSON.parse(content.params);
      let item = {};
      item.videoUrl = content.href;
      item.thumbUrl = content.thumb;
      item.duration = params.duration;
      item.width = params.video_width;
      item.height = params.video_height;
      item.fileSize = params.fileSize;
      item.properties = null;
      return item;
    },
    getCardBusiness(message) {
      let content = JSON.parse(message.content);
      let uid = content.params;
      let item = {};
      item.contactUid = uid;
      let description = JSON.parse(content.description);
      item.qrCodeUrl = description.qrCodeUrl;
      if (description.phone) {
        item.phone = description.phone;
      }
      item.thumbUrl = content.thumb;
      return item;
    },
    getContact(search = false) {
      if (search) {
        this.pageInfo.page = 1;
      }
      let body = {
        accountId: this.accountId,
        searchKey: this.searchKey,
        selectedTags: this.selectedTags.length > 0 ? this.selectedTags : null,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        type: this.conversationType,
        sortOption: this.sortOption
      };
      this.$http.post("/api/conversation/all", body).then((rep) => {
        this.pageInfo.total = rep.data.totalElements;
        this.views = rep.data.content;
        this.views = this.views.filter((c) => c.toId != this.conversation.accountId);
        if (this.app.allGroupIds.has(body.accountId)) {
          let allGroupIds = this.app.allGroupIds.get(body.accountId);
          this.views = this.views.filter((s) => {
            if (s.group === true) {
              return !!allGroupIds.includes(s.toId);
            } else return true;
          });
        }
        this.groupViews = groupByName(this.views, "swName", "toName");
      });
    },
    closeDialog() {
      this.$emit("closeSharePopupMulti");
    },
    send() {
      this.messages.forEach(mes => {
        this.sendOne(mes);
      })
    },
    sendOne(message) {
      if (this.shareContactCard) {
        return this.onSendContactCard();
      }

      let request = {
        accountId: this.accountId,
        toIds: this.conversationsSelected.filter((s) => s.group !== true).map((s) => s.toId),
        toGroupIds: this.conversationsSelected.filter((s) => s.group === true).map((s) => s.toId),
      };
      if (request.toIds.length === 0 && request.toGroupIds.length === 0) return this.alertError("Bạn chưa chọn cuộc trò chuyện");

      if (message.isArray) {
        if (message.type === COMMON.CHAT_FILE) {
          message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getFileParams(s)),
              msgType: 19,
            };
            this.isDisable = true;
            this.sendShareMessage(newRequest);
          });
          return;
        } else {
          message.messages.forEach((s) => {
            const newRequest = {
              ...request,
              message: JSON.stringify(this.getPhotoParams(s)),
              msgType: 2,
            };
            this.sendShareMessage(newRequest);
          });
          return;
        }
      }

      if (message.groupLayoutId === null) {
        request = {
          ...request,
          message: this.getMessage(message),
          msgType: this.getMsgType(message),
        };
        if (this.isText(message) && this.getMessage(message).trim().length === 0) return this.alertError("Vui lòng nhập nội dung tin nhắn");
        this.isDisable = true;
        this.sendShareMessage(request);
      } else {
        this.isDisable = true;
        message.groupImages.forEach((s) => {
          request = {
            ...request,
            message: JSON.stringify({ ...this.getPhotoParams(s), groupLayoutId: new Date().getTime() }),
            msgType: 2,
          };
          this.sendShareMessage(request);
        });
      }

      if ((message.groupLayoutId || this.isVideo(message) || this.isCardBusiness(message) || this.isFile(message)) && message.messageContent) {
        request = {
          ...request,
          message: message.messageContent,
          msgType: 1,
        };
        if (this.isText(message) && this.getMessage(message).trim().length === 0) return this.alertError("Vui lòng nhập nội dung tin nhắn");
        this.isDisable = true;
        setTimeout(() => {
          this.sendShareMessage(request);
        }, 200);
      }
    },
    currentSwPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getContact();
    },
    changeConversationType(type) {
      this.conversationType = type;
      this.getContact();
    },
    removeAllConversations() {
      this.conversationsSelected = [];
    },
    async onSendContactCard() {
      await Promise.all(
        this.conversationsSelected.map(async (conv) => {
          await this.$http.post("/api/message/sendContact", {
            accountId: this.shareContactCard.accountId,
            friendId: `${this.shareContactCard.accountId}_${this.shareContactCard.friendId}_0_0`,
            toId: conv.toId,
            conversationId: conv.id,
          });
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
      );
      this.closeDialog();
    },

    sendShareMessage(request) {
      this.$http
        .post("/api/message/forwardMessage", request)
        .then(() => {
          this.alert("success", "Chia sẻ tin nhắn thành công");
        })
        .finally(() => this.closeDialog());
    },
    search() {
      this.views = this.conversations
        .filter((s) => {
          if (s.toName === null) return;
          if (s.swName) {
            let isExist = s.swName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
            if (isExist) return true;
          }
          return s.toName.toLowerCase().trim().includes(this.searchKey.toLowerCase().trim());
        })
        .filter((s) => {
          if (this.selectedTags.length === 0) return true;
          else return s.tags.map((s) => s.id).some((t) => this.selectedTags.includes(t));
        });
    },

    addOrRemoveTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
      this.getContact(true);
    },

    isSelected(tag) {
      let index = this.selectedTags.indexOf(tag.id);
      return index > -1;
    },
    checkSelectedContact(id) {
      return this.conversationsSelected.findIndex((con) => con.id === id) !== -1;
    },
    selectItem(item) {
      if (this.conversationsSelected.length > this.LIMIT) return;
      let filter = this.conversationsSelected.filter((con) => con.id === item.id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      } else {
        this.conversationsSelected.push(item);
      }
    },
    unSelect(id) {
      let filter = this.conversationsSelected.filter((con) => con.id === id);
      if (filter != null && filter.length > 0) {
        const index = this.conversationsSelected.indexOf(filter[0]);
        if (index > -1) {
          this.conversationsSelected.splice(index, 1);
        }
      }
    },
    searchKeyChanged() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.getContact(true);
      }, 300);
    },
    getMsgType(message) {
      if (this.isText(message)) {
        return 1;
      } else if (this.isPhoto(message)) {
        return 2;
      } else if (this.isVideo(message)) {
        return 5;
      } else if (this.isCardBusiness(message)) {
        return 6;
      } else if (this.isFile(message)) {
        return 19;
      }
    },
    getMessage(message) {
      if (this.isText(message)) {
        return message.messageContent;
      } else if (this.isPhoto(message)) {
        message.photoContent.title = message.messageContent;
        return JSON.stringify(message.photoContent);
      } else if (this.isVideo(message)) {
        return JSON.stringify(message.photoContent);
      } else if (this.isCardBusiness(message)) {
        delete message.photoContent.thumbUrl;
        return JSON.stringify(message.photoContent);
      } else if (this.isFile(message)) {
        return JSON.stringify(message.photoContent);
      }
    },
  },
  mounted() {
    this.messages.forEach((message) => {
      this.$set(message, "groupImages", []);
      let parsed = null;
      try {
        parsed = message.content ? JSON.parse(message.content) : null;
      } catch (e) {
        parsed = null;
      }

      // WEBCHAT
      if (message.msgType === "webchat") {
        this.$set(
          message,
          "messageContent",
          this.isActionText(message) ? parsed?.title : message.content
        );
      }

      // PHOTO
      else if (message.msgType === "chat.photo") {
        this.$set(message, "photoContent", this.getPhotoParams(message));
        this.$set(message, "messageContent", message.photoContent?.title || "");

        if (this.isPhotoGroup(message)) {
          const paramsRaw = parsed?.params;

          if (paramsRaw) {
            try {
              const params = JSON.parse(paramsRaw);
              if (params.is_group_layout) {
                this.$set(message, "groupLayoutId", params.group_layout_id);
              }
            } catch (e) {
              console.log(e);

            }
          }

          this.getPhotoList(message);
        }
      }

      // VIDEO
      else if (this.isVideo(message)) {
        this.$set(message, "photoContent", this.getVideoParams(message));
        this.$set(message, "messageContent", "");
      }

      // CARD BUSINESS
      else if (this.isCardBusiness(message)) {
        this.$set(message, "photoContent", this.getCardBusiness(message));
        this.$set(message, "messageContent", "");
      }

      // FILE
      else if (this.isFile(message)) {
        this.$set(message, "photoContent", this.getFileParams(message));
        this.$set(message, "messageContent", "");
      }

      else if (message.isArray) {
        this.$set(message, "messageContent", "");
      }
    });

    this.getContact();
  }

}
</script>